import { all, call, put, select } from 'redux-saga/effects';
import TripsClient from '../../api/TripsClient';
import { setOngoingTripReceiptsLoading, setOngoingTripReceipts } from '../../redux/billing/actions';
import { userOngoingTripsIdsSelector } from '../../selectors/user';
import { messagesShow } from '../../redux/messages/actions';

export function* getOngoingTripReceiptsSaga() {
    try {
        yield put(setOngoingTripReceiptsLoading(true));

        const ongoingTripsIds = yield select(userOngoingTripsIdsSelector);
        const requests = ongoingTripsIds.map(tripId => call(TripsClient.getOngoingTripsReceipts, tripId));
        const receipts = yield all(requests);

        const ongoingTripsReceipts = receipts.reduce((acc, receiptsForTrip, index) => {
            const tripId = ongoingTripsIds[index];

            const namedReceipts = receiptsForTrip.reduce((receiptMap, receipt, receiptIndex) => {
                const map = receiptMap || {};
                const receiptKey = receipt.id || `receipt${receiptIndex}`;
                map[receiptKey] = receipt;
                return map;
            }, {});

            acc[tripId] = namedReceipts;
            return acc;
        }, {});

        yield put(setOngoingTripReceipts(ongoingTripsReceipts));
    } catch (error) {
        console.error('Error fetching ongoing trip receipts:', error);
        yield put(messagesShow('billingPage.ongoingTripsPage.notifications.receiptsFetchError', 'error'));
    } finally {
        yield put(setOngoingTripReceiptsLoading(false));
    }
}
